import { useDispatch } from 'react-redux'
import { Payload, Query } from 'redux-first-router'

import { redirectToThunk } from '~shared-components/redux/actions/redirect.actions'
import { Page } from '~shared-components/utils/enums'

export const useRedirect = (customLocationPayload?: Payload) => {
  const dispatch = useDispatch()

  return (page: Page, payload: Payload = {}, query?: Query) => {
    dispatch(
      redirectToThunk({
        payload: {
          ...customLocationPayload,
          ...payload,
        },
        query,
        type: page,
      }),
    )
  }
}
